import {
  getDataFields,
  getCustomizationField,
} from "../components/VizComponents/Pie/controlPanel";
import {
  getDataFieldsBar,
  getCustomizationFieldBar,
} from "../components/VizComponents/BarChart/controlPanel";
import {
  getDataFieldsPivotTable,
  getCustomizationFieldPivotTable,
} from "../components/VizComponents/PivotTable/controlPanal";
import {
  getDataFieldsTable,
  getCustomizationFieldsTable,
} from "../components/VizComponents/Table/controlPanel";
import {
  getDataFieldline,
  getCustomizationFieldline,
} from "../components/VizComponents/Line/controlPanel";
import {
  getRankTileDataFields,
  getRankTileCustomizationFields,
} from "../components/VizComponents/RankTile/controlPanel";
import {
  getDataFieldsArea,
  getCustomizationFieldArea,
} from "../components/VizComponents/Area/controlPanel";

import {
  getDataFieldsScatter,
  getCustomizationFieldScatter,
} from "../components/VizComponents/Scatter/controlPanel";
import {
  getDataFieldsTree,
  getCustomizationFieldTree,
} from "../components/VizComponents/Tree/controlPanel";
import {
  getDataFieldsstacked,
  getCustomizationFieldStacked,
} from "../components/VizComponents/Stacked/controlPanel";
import {
  getDataFieldsstackedimage,
  getCustomizationFieldStackedimage,
} from "../components/VizComponents/Stackedimage/controlPanel";
import {
  getDataFieldsCombochart,
  getCustomizationCombochart,
} from "../components/VizComponents/Combochart/controlPanel";
import {
  getDataFieldsMapData,
  getCustomizationMapData,
} from "../components/VizComponents/MapWithCordinate/controlpanel";
import ReduxPieComp from "../components/VizComponents/Pie/ReduxPieComp";
import BarChartComp from "../components/VizComponents/BarChart/BarChartComp";
import LineChartComp from "../components/VizComponents/Line/LineChartComp";
import AreaChartComp from "../components/VizComponents/Area/AreaChartComp";
import ScatterChartComp from "../components/VizComponents/Scatter/ScatterChartComp";
import TreeChartComp from "../components/VizComponents/Tree/TreeChartComp";
import StackedBarChartComp from "../components/VizComponents/Stacked/StackedBarChartComp";
import StackedBarImageComp from "../components/VizComponents/Stackedimage/StackedBarImageComp";
import PivotTable from "../components/VizComponents/PivotTable/PiviotTable";
import { buildIntialSheetState } from "./buildInitialSheetState";
import CordinateMap from "../components/VizComponents/MapWithCordinate/CordinateMap";
import {
  getNeedlePieCustomizationField,
  getNeedlePieDataFields,
} from "../components/VizComponents/PieChartWithNeedle/controlPanel";
import NeedlePieChart from "../components/VizComponents/PieChartWithNeedle/NeedlePieChart";
import Combochart from "../components/VizComponents/Combochart/Combochart";

import {
  getBigNumberDataFields,
  getBigNumberCustomizationFields,
} from "../components/VizComponents/BigNumber/controlPanel";

import BigNumberComp from "../components/VizComponents/BigNumber/BigNumberComp";
import RadarChartComp from "../components/VizComponents/Radar/RadarChartComp";
import {
  getRadarCustomizationFields,
  getRadarDataFields,
} from "../components/VizComponents/Radar/controllPanel";
import AreaMap from "../components/VizComponents/MapWithArea/AreaMap";
import {
  getCustomizationAreaMapData,
  getDataFieldsAreaMapData,
} from "../components/VizComponents/MapWithArea/controlpanel";
import Table from "../components/VizComponents/Table/Table";

export const getAside2components = (vizType) => {
  console.log(vizType);
  switch (vizType) {
    case "piechart": {
      const DataArrayComponents = getDataFields();
      const CustomizeArrayComponents = getCustomizationField();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "needlePie": {
      const DataArrayComponents = getNeedlePieDataFields();
      const CustomizeArrayComponents = getNeedlePieCustomizationField();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "simpleTable": {
      const DataArrayComponents = getDataFieldsPivotTable();
      const CustomizeArrayComponents = getCustomizationFieldPivotTable();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "table": {
      const DataArrayComponents = getDataFieldsTable();
      const CustomizeArrayComponents = getCustomizationFieldsTable();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "barchart": {
      const DataArrayComponents = getDataFieldsBar();
      const CustomizeArrayComponents = getCustomizationFieldBar();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "linechart": {
      const DataArrayComponents = getDataFieldline();
      const CustomizeArrayComponents = getCustomizationFieldline();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "areachart": {
      const DataArrayComponents = getDataFieldsArea();
      const CustomizeArrayComponents = getCustomizationFieldArea();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "scatterchart": {
      const DataArrayComponents = getDataFieldsScatter();
      const CustomizeArrayComponents = getCustomizationFieldScatter();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "treechart": {
      const DataArrayComponents = getDataFieldsTree();
      const CustomizeArrayComponents = getCustomizationFieldTree();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "bigNumber": {
      const DataArrayComponents = getBigNumberDataFields();
      const CustomizeArrayComponents = getBigNumberCustomizationFields();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "rankTile": {
      const DataArrayComponents = getRankTileDataFields();
      const CustomizeArrayComponents = getRankTileCustomizationFields();
      return { DataArrayComponents, CustomizeArrayComponents };
    }

    case "radarchart": {
      const DataArrayComponents = getRadarDataFields();
      const CustomizeArrayComponents = getRadarCustomizationFields();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "stackedbarchart": {
      const DataArrayComponents = getDataFieldsstacked();
      const CustomizeArrayComponents = getCustomizationFieldStacked();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "stackedbarchartimage": {
      const DataArrayComponents = getDataFieldsstackedimage();
      const CustomizeArrayComponents = getCustomizationFieldStackedimage();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "cordinatemap": {
      const DataArrayComponents = getDataFieldsMapData();
      const CustomizeArrayComponents = getCustomizationMapData();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "areamap": {
      const DataArrayComponents = getDataFieldsAreaMapData();
      const CustomizeArrayComponents = getCustomizationAreaMapData();
      return { DataArrayComponents, CustomizeArrayComponents };
    }
    case "combochart": {
      const DataArrayComponents = getDataFieldsCombochart();
      const CustomizeArrayComponents = getCustomizationCombochart();
      return { DataArrayComponents, CustomizeArrayComponents };
    }

    default: {
      // it's temporary default until we set all the cases
      const DataArrayComponents = getDataFields();
      const CustomizeArrayComponents = getCustomizationField();
      return { DataArrayComponents, CustomizeArrayComponents };
      // return ([]);
    }
  }
};

export const getAside3VizComponent = (vizType) => {
  console.log(vizType);
  switch (vizType) {
    case "piechart": {
      return (props) => <ReduxPieComp {...props} />;
    }
    case "needlePie": {
      return (props) => <NeedlePieChart {...props} />;
    }
    case "simpleTable": {
      return (props) => <PivotTable {...props} />;
    }
    case "table": {
      return (props) => <Table {...props} />;
    }
    case "barchart": {
      return (props) => <BarChartComp {...props} />;
    }
    case "linechart": {
      return (props) => <LineChartComp {...props} />;
    }
    case "areachart": {
      return (props) => <AreaChartComp {...props} />;
    }
    case "scatterchart": {
      return (props) => <ScatterChartComp {...props} />;
    }
    case "treechart": {
      return (props) => <TreeChartComp {...props} />;
    }
    case "bigNumber": {
      return (props) => <BigNumberComp {...props} />;
    }

    case "radarchart": {
      return (props) => <RadarChartComp {...props} />;
    }
    case "stackedbarchart": {
      return (props) => <StackedBarChartComp {...props} />;
    }
    case "stackedbarchartimage": {
      return (props) => <StackedBarImageComp {...props} />;
    }
    case "cordinatemap": {
      return (props) => <CordinateMap {...props} />;
    }
    case "areamap": {
      return (props) => <AreaMap {...props} />;
    }
    case "combochart": {
      return (props) => <Combochart {...props} />;
    }

    default: {
      // it's temporary default until we set all the cases
      return;
      // return ([]);
    }
  }
};

export const getDefaultReduxState = ({ vizType, dataSourceID, sheetName }) => {
  console.log(vizType);
  switch (vizType) {
    case "piechart": {
      const DataArrayComponents = getDataFields();
      const CustomizeArrayComponents = getCustomizationField();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      console.log(newSheetState);
      return { newSheetState };
    }
    case "needlePie": {
      const DataArrayComponents = getNeedlePieDataFields();
      const CustomizeArrayComponents = getNeedlePieCustomizationField();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      console.log(newSheetState);
      return { newSheetState };
    }
    case "simpleTable": {
      const DataArrayComponents = getDataFieldsPivotTable();
      const CustomizeArrayComponents = getCustomizationFieldPivotTable();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "table": {
      const DataArrayComponents = getDataFieldsTable();
      const CustomizeArrayComponents = getCustomizationFieldsTable();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "barchart": {
      const DataArrayComponents = getDataFieldsBar();
      const CustomizeArrayComponents = getCustomizationFieldBar();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "linechart": {
      const DataArrayComponents = getDataFieldline();
      const CustomizeArrayComponents = getCustomizationFieldline();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "areachart": {
      const DataArrayComponents = getDataFieldsArea();
      const CustomizeArrayComponents = getCustomizationFieldArea();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "scatterchart": {
      const DataArrayComponents = getDataFieldsScatter();
      const CustomizeArrayComponents = getCustomizationFieldScatter();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "treechart": {
      const DataArrayComponents = getDataFieldsTree();
      const CustomizeArrayComponents = getCustomizationFieldTree();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "bigNumber": {
      const DataArrayComponents = getBigNumberDataFields();
      const CustomizeArrayComponents = getBigNumberCustomizationFields();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      // console.log(newSheetState);
      return { newSheetState };
    }
    case "radarchart": {
      const DataArrayComponents = getRadarDataFields();
      const CustomizeArrayComponents = getRadarCustomizationFields();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      // console.log(newSheetState);
      return { newSheetState };
    }
    case "stackedbarchart": {
      const DataArrayComponents = getDataFieldsstacked();
      const CustomizeArrayComponents = getCustomizationFieldStacked();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "stackedbarchartimage": {
      const DataArrayComponents = getDataFieldsstackedimage();
      const CustomizeArrayComponents = getCustomizationFieldStackedimage();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "cordinatemap": {
      const DataArrayComponents = getDataFieldsMapData();
      const CustomizeArrayComponents = getCustomizationMapData();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "areamap": {
      const DataArrayComponents = getDataFieldsAreaMapData();
      const CustomizeArrayComponents = getCustomizationAreaMapData();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    case "combochart": {
      const DataArrayComponents = getDataFieldsCombochart();
      const CustomizeArrayComponents = getCustomizationCombochart();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
    default: {
      const DataArrayComponents = getDataFields();
      const CustomizeArrayComponents = getCustomizationField();
      const newSheetState = buildIntialSheetState(
        vizType,
        CustomizeArrayComponents,
        DataArrayComponents,
        dataSourceID,
        sheetName
      );
      return { newSheetState };
    }
  }
};
